import React, { Component } from "react"
import DataSourceListItem from "./DataSourceListItem"
import PaginationButtons from "../../../../reuseable-components/PaginationButtons";


class DataSourceList extends Component {

  render() {
    const { dataSources, getDataSources, numberOfPages, currentPage, buttonsPerPage } = this.props

    if (dataSources.length) {
      return (
        <div>
          <center>
            <PaginationButtons
              onClick={ getDataSources }
              numberOfPages={ numberOfPages }
              currentPage={ currentPage }
              buttonsPerPage={ buttonsPerPage }
            />
          </center>
          <table className="data-access-request-table">
            <thead>
              <tr className="data-access-request-table-head">
                <th>Name</th>
                <th>Client</th>
              </tr>
            </thead>
            <tbody>
              { dataSources.map(dataSource => (
                <DataSourceListItem key={ dataSource.id } dataSource={ dataSource } getDataSources={ getDataSources } />
              )) }
            </tbody>
          </table>
        </div>
      )
    } else {
      return (
        <center>
          <h5>There are no data sources that are matching current filters...</h5>
        </center>
      )
    }

  }
}

export default DataSourceList


// WEBPACK FOOTER //
// ./src/routes/data-access-request/DataAccessRequestManager/components/DataSourceList.js